import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('name required'),
  theme: Yup.string(),
  email: Yup.string().email().required('email required'),
});
